(function(exports){
	//http://stackoverflow.com/questions/3225251/how-can-i-share-code-between-node-js-and-the-browser
	exports.cleanseText = function(str){
		var entityName = {
			"lt":"<",
			"gt":">",
			"amp":"&",
			"acute":"´",
			"cedil":"¸",
			"circ":"ˆ",
			"macr":"¯",
			"middot":"·",
			"tilde":"˜",
			"uml":"¨",
			"Aacute":"Á",
			"aacute":"á",
			"Acirc":"Â",
			"acirc":"â",
			"AElig":"Æ",
			"aelig":"æ",
			"Agrave":"À",
			"agrave":"à",
			"Aring":"Å",
			"aring":"å",
			"Atilde":"Ã",
			"atilde":"ã",
			"Auml":"Ä",
			"auml":"ä",
			"Ccedil":"Ç",
			"ccedil":"ç",
			"Eacute":"É",
			"eacute":"é",
			"Ecirc":"Ê",
			"ecirc":"ê",
			"Egrave":"È",
			"egrave":"è",
			"ETH":"Ð",
			"eth":"ð",
			"Euml":"Ë",
			"euml":"ë",
			"Iacute":"Í",
			"iacute":"í",
			"Icirc":"Î",
			"icirc":"î",
			"Igrave":"Ì",
			"igrave":"ì",
			"Iuml":"Ï",
			"iuml":"ï",
			"Ntilde":"Ñ",
			"ntilde":"ñ",
			"Oacute":"Ó",
			"oacute":"ó",
			"Ocirc":"Ô",
			"ocirc":"ô",
			"OElig":"Œ",
			"oelig":"œ",
			"Ograve":"Ò",
			"ograve":"ò",
			"Oslash":"Ø",
			"oslash":"ø",
			"Otilde":"Õ",
			"otilde":"õ",
			"Ouml":"Ö",
			"ouml":"ö",
			"Scaron":"Š",
			"scaron":"š",
			"szlig":"ß",
			"THORN":"Þ",
			"thorn":"þ",
			"Uacute":"Ú",
			"uacute":"ú",
			"Ucirc":"Û",
			"ucirc":"û",
			"Ugrave":"Ù",
			"ugrave":"ù",
			"Uuml":"Ü",
			"uuml":"ü",
			"Yacute":"Ý",
			"yacute":"ý",
			"yuml":"ÿ",
			"Yuml":"Ÿ",
			"cent":"¢",
			"curren":"¤",
			"euro":"€",
			"pound":"£",
			"yen":"¥",
			"brvbar":"¦",
			"bull":"•",
			"copy":"©",
			"dagger":"†",
			"Dagger":"‡",
			"frasl":"⁄",
			"hellip":"…",
			"iexcl":"¡",
			"image":"ℑ",
			"iquest":"¿",
			"lrm":"‎",
			"mdash":"—",
			"ndash":"–",
			"not":"¬",
			"oline":"‾",
			"ordf":"ª",
			"ordm":"º",
			"para":"¶",
			"permil":"‰",
			"prime":"′",
			"Prime":"″",
			"real":"ℜ",
			"reg":"®",
			"rlm":"‏",
			"sect":"§",
			"sup1":"¹",
			"trade":"™",
			"weierp":"℘",
			"bdquo":"„",
			"laquo":"«",
			"ldquo":"“",
			"lsaquo":"‹",
			"lsquo":"‘",
			"raquo":"»",
			"rdquo":"”",
			"rsaquo":"›",
			"rsquo":"’",
			"sbquo":"‚",
			"emsp":" ",
			"ensp":" ",
			"nbsp":" ",
			"thinsp":" ",
			"zwj":"‍",
			"zwnj":"‌",
			"deg":"°",
			"divide":"÷",
			"frac12":"½",
			"frac14":"¼",
			"frac34":"¾",
			"ge":"≥",
			"le":"≤",
			"minus":"−",
			"sup2":"²",
			"sup3":"³",
			"times":"×",
			"alefsym":"ℵ",
			"and":"∧",
			"ang":"∠",
			"asymp":"≈",
			"cap":"∩",
			"cong":"≅",
			"cup":"∪",
			"empty":"∅",
			"equiv":"≡",
			"exist":"∃",
			"fnof":"ƒ",
			"forall":"∀",
			"infin":"∞",
			"int":"∫",
			"isin":"∈",
			"lang":"⟨",
			"lceil":"⌈",
			"lfloor":"⌊",
			"lowast":"∗",
			"micro":"µ",
			"nabla":"∇",
			"ne":"≠",
			"ni":"∋",
			"notin":"∉",
			"nsub":"⊄",
			"oplus":"⊕",
			"or":"∨",
			"otimes":"⊗",
			"part":"∂",
			"perp":"⊥",
			"plusmn":"±",
			"prod":"∏",
			"prop":"∝",
			"radic":"√",
			"rang":"⟩",
			"rceil":"⌉",
			"rfloor":"⌋",
			"sdot":"⋅",
			"sim":"∼",
			"sub":"⊂",
			"sube":"⊆",
			"sum":"∑",
			"sup":"⊃",
			"supe":"⊇",
			"there4":"∴",
			"Alpha":"Α",
			"alpha":"α",
			"Beta":"Β",
			"beta":"β",
			"Chi":"Χ",
			"chi":"χ",
			"Delta":"Δ",
			"delta":"δ",
			"Epsilon":"Ε",
			"epsilon":"ε",
			"Eta":"Η",
			"eta":"η",
			"Gamma":"Γ",
			"gamma":"γ",
			"Iota":"Ι",
			"iota":"ι",
			"Kappa":"Κ",
			"kappa":"κ",
			"Lambda":"Λ",
			"lambda":"λ",
			"Mu":"Μ",
			"mu":"μ",
			"Nu":"Ν",
			"nu":"ν",
			"Omega":"Ω",
			"omega":"ω",
			"Omicron":"Ο",
			"omicron":"ο",
			"Phi":"Φ",
			"phi":"φ",
			"Pi":"Π",
			"pi":"π",
			"piv":"ϖ",
			"Psi":"Ψ",
			"psi":"ψ",
			"quot":"\"",
			"Rho":"Ρ",
			"rho":"ρ",
			"Sigma":"Σ",
			"sigma":"σ",
			"sigmaf":"ς",
			"Tau":"Τ",
			"tau":"τ",
			"Theta":"Θ",
			"theta":"θ",
			"thetasym":"ϑ",
			"upsih":"ϒ",
			"Upsilon":"Υ",
			"upsilon":"υ",
			"Xi":"Ξ",
			"xi":"ξ",
			"Zeta":"Ζ",
			"zeta":"ζ",
			"crarr":"↵",
			"darr":"↓",
			"dArr":"⇓",
			"harr":"↔",
			"hArr":"⇔",
			"larr":"←",
			"lArr":"⇐",
			"rarr":"→",
			"rArr":"⇒",
			"uarr":"↑",
			"uArr":"⇑",
			"clubs":"♣",
			"diams":"♦",
			"hearts":"♥",
			"spades":"♠",
			"loz":"◊"
		};
		if(typeof str == 'undefined')
			return "";
		str = str.replace(/&([A-Za-z]+);/g, function(fullStr, match){return entityName.hasOwnProperty(match) ? entityName[match] : fullStr});
		str = str.replace(/&#(\d{1,4});/, function(fullStr, code) { return String.fromCharCode(code); });
		

		str = str.replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi,' '); //removes script section entirely
		str = str.replace(/<iframe\b[^<]*(?:(?!<\/iframe>)<[^<]*)*<\/iframe>/gi,' '); //removes iframe section entirely
		str = str.replace(/<head\b[^<]*(?:(?!<\/head>)<[^<]*)*<\/head>/gi,' '); //removes head section entirely
		str = str.replace(/<style\b[^<]*(?:(?!<\/style>)<[^<]*)*<\/style>/gi,' '); //removes style section entirely

		str = str.replace(/<(?:.|\n)*?>/gm,' '); //remove all remaining tags

		str = str.replace(/\s{2,}/g, ' '); //replace more than one space with a single space
		str = str.replace(/(\s)([!,./;”])(\s)/g, '$2$3') //remove leading space before punctuation (" . ",  " , ")
		str = str.replace(/(\s)([“])(\s)/g, '$1$2') //remove trailing space after quote (' " ')
		str = str.replace(/^\s+/,''); //remove lead space
		return str;
	}
	exports.getImageUrl = function(item, size, imageKey){
		if(typeof imageKey === 'undefined') imageKey = "image"
		if(typeof item == 'undefined' || typeof item[imageKey] == 'undefined') return null;
		var imageName = item[imageKey];
		if(size=='quarter'){
			if(typeof item.old_id == "undefined"){
				return "https://7676076fde29cb34e26d-759f611b127203e9f2a0021aa1b7da05.ssl.cf2.rackcdn.com/940/" + encodeURIComponent(imageName).replace("'","%27");
			}else{
				return "https://7676076fde29cb34e26d-759f611b127203e9f2a0021aa1b7da05.ssl.cf2.rackcdn.com/fs/" + encodeURIComponent(imageName).replace("'","%27");
			}
		}
		if(size=='featured'){
			if(typeof item.old_id == "undefined"){
				return "https://7676076fde29cb34e26d-759f611b127203e9f2a0021aa1b7da05.ssl.cf2.rackcdn.com/940/" + encodeURIComponent(imageName).replace("'","%27");
			}else{
				return "https://7676076fde29cb34e26d-759f611b127203e9f2a0021aa1b7da05.ssl.cf2.rackcdn.com/fs/" + encodeURIComponent(imageName).replace("'","%27");
			}
		}
	}
	exports.cleanseCopy = function(str,len){
		if(typeof len != 'number' || len < 0)
			len = 300;
		var summaryText = this.cleanseText(str).substr(0,len);
		summaryText = summaryText.substr(0, summaryText.lastIndexOf(' '));
		var lastChar = summaryText.substr(summaryText.length - 1);
		if(/[a-zA-Z0-9]/.test(lastChar)) //makes sure last char is not punctuation before adding elipse
			summaryText += '...';
		return summaryText;
	};
	exports.getMinutesToRead = function(copy){
		var cleansedCopy = this.cleanseCopy(copy,10000); // Putting length at 10,000 to capture the length of all articles
		var numberOfWords = cleansedCopy.split(' ').length;
		var minutesToRead = numberOfWords / 200;
		return Math.ceil(minutesToRead || 1); // Round up
	}

	//Address Fields code
	//Modified code from Kimbia to mimic form-regeneration based on Country Code

	//Last Modified by Philip Brown

	//******RUN THIS FUNCTION TO GET THE ADDRESS FIELDS FOR A COUNTRY
	exports.getAddressFieldsByCountryCode = function(alpha2CountryCode){  //Only compatible with 2x Alpha country codes(correct:"US",incorrect:"USA")
	    if(typeof addressFieldsByCountryCode[alpha2CountryCode] !== 'undefined')
	        return addressFieldsByCountryCode[alpha2CountryCode];
	    else
	        return addressFieldsByCountryCode.DEFAULT;
	}
	exports.listOfCountries = [{a:"AC",n:"AscensionIsland"},{a:"AD",n:"Andorra"},{a:"AE",n:"UnitedArabEmirates"},{a:"AF",n:"Afghanistan"},{a:"AG",n:"AntiguaAndBarbuda"},{a:"AI",n:"Anguilla"},{a:"AI",n:"FrenchAfarandIssas"},{a:"AL",n:"Albania"},{a:"AM",n:"Armenia"},{a:"AN",n:"NetherlandsAntilles"},{a:"AO",n:"Angola"},{a:"AQ",n:"Antarctica"},{a:"AR",n:"Argentina"},{a:"AS",n:"AmericanSamoa"},{a:"AT",n:"Austria"},{a:"AU",n:"Australia"},{a:"AW",n:"Aruba"},{a:"AX",n:"ÅlandIslands"},{a:"AZ",n:"Azerbaijan"},{a:"BA",n:"Bosnia&Herzegovina"},{a:"BB",n:"Barbados"},{a:"BD",n:"Bangladesh"},{a:"BE",n:"Belgium"},{a:"BF",n:"BurkinaFaso"},{a:"BG",n:"Bulgaria"},{a:"BH",n:"Bahrain"},{a:"BI",n:"Burundi"},{a:"BJ",n:"Benin"},{a:"BL",n:"SaintBarthélemy"},{a:"BM",n:"Bermuda"},{a:"BN",n:"BruneiDarussalam"},{a:"BO",n:"Bolivia,PlurinationalStateOf"},{a:"BQ",n:"Bonaire,SaintEustatiusAndSaba"},{a:"BQ",n:"BritishAntarcticTerritory"},{a:"BR",n:"Brazil"},{a:"BS",n:"Bahamas"},{a:"BT",n:"Bhutan"},{a:"BU",n:"Burma"},{a:"BV",n:"BouvetIsland"},{a:"BW",n:"Botswana"},{a:"BY",n:"Belarus"},{a:"BY",n:"ByelorussianSSR"},{a:"BZ",n:"Belize"},{a:"CA",n:"Canada"},{a:"CC",n:"Cocos(Keeling)Islands"},{a:"CD",n:"DemocraticRepublicOfCongo"},{a:"CF",n:"CentralAfricanRepublic"},{a:"CG",n:"RepublicOfCongo"},{a:"CH",n:"Switzerland"},{a:"CI",n:"Côted'Ivoire"},{a:"CK",n:"CookIslands"},{a:"CL",n:"Chile"},{a:"CM",n:"Cameroon"},{a:"CN",n:"China"},{a:"CO",n:"Colombia"},{a:"CP",n:"ClippertonIsland"},{a:"CR",n:"CostaRica"},{a:"CS",n:"Czechoslovakia"},{a:"CS",n:"SerbiaandMontenegro"},{a:"CT",n:"CantonandEnderburyIslands"},{a:"CU",n:"Cuba"},{a:"CV",n:"CaboVerde"},{a:"CW",n:"Curacao"},{a:"CX",n:"ChristmasIsland"},{a:"CY",n:"Cyprus"},{a:"CZ",n:"CzechRepublic"},{a:"DD",n:"GermanDemocraticRepublic"},{a:"DE",n:"Germany"},{a:"DG",n:"DiegoGarcia"},{a:"DJ",n:"Djibouti"},{a:"DK",n:"Denmark"},{a:"DM",n:"Dominica"},{a:"DO",n:"DominicanRepublic"},{a:"DY",n:"Dahomey"},{a:"DZ",n:"Algeria"},{a:"EA",n:"Ceuta,Mulilla"},{a:"EC",n:"Ecuador"},{a:"EE",n:"Estonia"},{a:"EG",n:"Egypt"},{a:"EH",n:"WesternSahara"},{a:"ER",n:"Eritrea"},{a:"ES",n:"Spain"},{a:"ET",n:"Ethiopia"},{a:"EU",n:"EuropeanUnion"},{a:"FI",n:"Finland"},{a:"FJ",n:"Fiji"},{a:"FK",n:"FalklandIslands"},{a:"FM",n:"Micronesia,FederatedStatesOf"},{a:"FO",n:"FaroeIslands"},{a:"FQ",n:"FrenchSouthernandAntarcticTerritories"},{a:"FR",n:"France"},{a:"FX",n:"France,Metropolitan"},{a:"GA",n:"Gabon"},{a:"GB",n:"UnitedKingdom"},{a:"GD",n:"Grenada"},{a:"GE",n:"Georgia"},{a:"GE",n:"GilbertandElliceIslands"},{a:"GF",n:"FrenchGuiana"},{a:"GG",n:"Guernsey"},{a:"GH",n:"Ghana"},{a:"GI",n:"Gibraltar"},{a:"GL",n:"Greenland"},{a:"GM",n:"Gambia"},{a:"GN",n:"Guinea"},{a:"GP",n:"Guadeloupe"},{a:"GQ",n:"EquatorialGuinea"},{a:"GR",n:"Greece"},{a:"GS",n:"SouthGeorgiaAndTheSouthSandwichIslands"},{a:"GT",n:"Guatemala"},{a:"GU",n:"Guam"},{a:"GW",n:"Guinea-bissau"},{a:"GY",n:"Guyana"},{a:"HK",n:"HongKong"},{a:"HM",n:"HeardIslandAndMcDonaldIslands"},{a:"HN",n:"Honduras"},{a:"HR",n:"Croatia"},{a:"HT",n:"Haiti"},{a:"HU",n:"Hungary"},{a:"HV",n:"UpperVolta"},{a:"IC",n:"CanaryIslands"},{a:"ID",n:"Indonesia"},{a:"IE",n:"Ireland"},{a:"IL",n:"Israel"},{a:"IM",n:"IsleOfMan"},{a:"IN",n:"India"},{a:"IO",n:"BritishIndianOceanTerritory"},{a:"IQ",n:"Iraq"},{a:"IR",n:"Iran,IslamicRepublicOf"},{a:"IS",n:"Iceland"},{a:"IT",n:"Italy"},{a:"JE",n:"Jersey"},{a:"JM",n:"Jamaica"},{a:"JO",n:"Jordan"},{a:"JP",n:"Japan"},{a:"JT",n:"JohnstonIsland"},{a:"KE",n:"Kenya"},{a:"KG",n:"Kyrgyzstan"},{a:"KH",n:"Cambodia"},{a:"KI",n:"Kiribati"},{a:"KM",n:"Comoros"},{a:"KN",n:"SaintKittsAndNevis"},{a:"KP",n:"Korea,DemocraticPeople'sRepublicOf"},{a:"KR",n:"Korea,RepublicOf"},{a:"KW",n:"Kuwait"},{a:"KY",n:"CaymanIslands"},{a:"KZ",n:"Kazakhstan"},{a:"LA",n:"LaoPeople'sDemocraticRepublic"},{a:"LB",n:"Lebanon"},{a:"LC",n:"SaintLucia"},{a:"LI",n:"Liechtenstein"},{a:"LK",n:"SriLanka"},{a:"LR",n:"Liberia"},{a:"LS",n:"Lesotho"},{a:"LT",n:"Lithuania"},{a:"LU",n:"Luxembourg"},{a:"LV",n:"Latvia"},{a:"LY",n:"Libya"},{a:"MA",n:"Morocco"},{a:"MC",n:"Monaco"},{a:"MD",n:"Moldova"},{a:"ME",n:"Montenegro"},{a:"MF",n:"SaintMartin"},{a:"MG",n:"Madagascar"},{a:"MH",n:"MarshallIslands"},{a:"MI",n:"MidwayIslands"},{a:"MK",n:"Macedonia,TheFormerYugoslavRepublicOf"},{a:"ML",n:"Mali"},{a:"MM",n:"Myanmar"},{a:"MN",n:"Mongolia"},{a:"MO",n:"Macao"},{a:"MP",n:"NorthernMarianaIslands"},{a:"MQ",n:"Martinique"},{a:"MR",n:"Mauritania"},{a:"MS",n:"Montserrat"},{a:"MT",n:"Malta"},{a:"MU",n:"Mauritius"},{a:"MV",n:"Maldives"},{a:"MW",n:"Malawi"},{a:"MX",n:"Mexico"},{a:"MY",n:"Malaysia"},{a:"MZ",n:"Mozambique"},{a:"NA",n:"Namibia"},{a:"NC",n:"NewCaledonia"},{a:"NE",n:"Niger"},{a:"NF",n:"NorfolkIsland"},{a:"NG",n:"Nigeria"},{a:"NH",n:"NewHebrides"},{a:"NI",n:"Nicaragua"},{a:"NL",n:"Netherlands"},{a:"NO",n:"Norway"},{a:"NP",n:"Nepal"},{a:"NQ",n:"DronningMaudLand"},{a:"NR",n:"Nauru"},{a:"NT",n:"NeutralZone"},{a:"NU",n:"Niue"},{a:"NZ",n:"NewZealand"},{a:"OM",n:"Oman"},{a:"PA",n:"Panama"},{a:"PC",n:"PacificIslands,TrustTerritoryofthe"},{a:"PE",n:"Peru"},{a:"PF",n:"FrenchPolynesia"},{a:"PG",n:"PapuaNewGuinea"},{a:"PH",n:"Philippines"},{a:"PK",n:"Pakistan"},{a:"PL",n:"Poland"},{a:"PM",n:"SaintPierreAndMiquelon"},{a:"PN",n:"Pitcairn"},{a:"PR",n:"PuertoRico"},{a:"PS",n:"PalestinianTerritory,Occupied"},{a:"PT",n:"Portugal"},{a:"PU",n:"U.S.MiscellaneousPacificIslands"},{a:"PW",n:"Palau"},{a:"PY",n:"Paraguay"},{a:"PZ",n:"PanamaCanalZone"},{a:"QA",n:"Qatar"},{a:"RE",n:"Reunion"},{a:"RH",n:"SouthernRhodesia"},{a:"RO",n:"Romania"},{a:"RS",n:"Serbia"},{a:"RU",n:"RussianFederation"},{a:"RW",n:"Rwanda"},{a:"SA",n:"SaudiArabia"},{a:"SB",n:"SolomonIslands"},{a:"SC",n:"Seychelles"},{a:"SD",n:"Sudan"},{a:"SE",n:"Sweden"},{a:"SG",n:"Singapore"},{a:"SH",n:"SaintHelena,AscensionAndTristanDaCunha"},{a:"SI",n:"Slovenia"},{a:"SJ",n:"SvalbardAndJanMayen"},{a:"SK",n:"Slovakia"},{a:"SK",n:"Sikkim"},{a:"SL",n:"SierraLeone"},{a:"SM",n:"SanMarino"},{a:"SN",n:"Senegal"},{a:"SO",n:"Somalia"},{a:"SR",n:"Suriname"},{a:"SS",n:"SouthSudan"},{a:"ST",n:"SaoTomeandPrincipe"},{a:"SU",n:"USSR"},{a:"SV",n:"ElSalvador"},{a:"SX",n:"SintMaarten"},{a:"SY",n:"SyrianArabRepublic"},{a:"SZ",n:"Swaziland"},{a:"TA",n:"TristandeCunha"},{a:"TC",n:"TurksAndCaicosIslands"},{a:"TD",n:"Chad"},{a:"TF",n:"FrenchSouthernTerritories"},{a:"TG",n:"Togo"},{a:"TH",n:"Thailand"},{a:"TJ",n:"Tajikistan"},{a:"TK",n:"Tokelau"},{a:"TL",n:"Timor-Leste,DemocraticRepublicof"},{a:"TM",n:"Turkmenistan"},{a:"TN",n:"Tunisia"},{a:"TO",n:"Tonga"},{a:"TP",n:"EastTimor"},{a:"TR",n:"Turkey"},{a:"TT",n:"TrinidadAndTobago"},{a:"TV",n:"Tuvalu"},{a:"TW",n:"Taiwan"},{a:"TZ",n:"Tanzania,UnitedRepublicOf"},{a:"UA",n:"Ukraine"},{a:"UG",n:"Uganda"},{a:"UK",n:"UnitedKingdom"},{a:"UM",n:"UnitedStatesMinorOutlyingIslands"},{a:"US",n:"UnitedStates"},{a:"UY",n:"Uruguay"},{a:"UZ",n:"Uzbekistan"},{a:"VA",n:"VaticanCityState"},{a:"VC",n:"SaintVincentAndTheGrenadines"},{a:"VD",n:"Viet-Nam,DemocraticRepublicof"},{a:"VE",n:"Venezuela,BolivarianRepublicOf"},{a:"VG",n:"VirginIslands(British)"},{a:"VI",n:"VirginIslands(US)"},{a:"VN",n:"VietNam"},{a:"VU",n:"Vanuatu"},{a:"WF",n:"WallisAndFutuna"},{a:"WK",n:"WakeIsland"},{a:"WS",n:"Samoa"},{a:"XK",n:"Kosovo"},{a:"YD",n:"Yemen,Democratic"},{a:"YE",n:"Yemen"},{a:"YT",n:"Mayotte"},{a:"YU",n:"Yugoslavia"},{a:"ZA",n:"SouthAfrica"},{a:"ZM",n:"Zambia"},{a:"ZR",n:"Zaire"},{a:"ZW",n:"Zimbabwe"}];
	//Should work for all countries(fingers crossed) - use this to determine if member profile is finished
	exports.addressCompleted = function(member){
		if(typeof member !== 'object' || Object.keys(member).length < 1)
			return 'empty';
	  var partial = false;
	  var completed = true;
	  var country = 'US';
	  if(member.country && member.country !== 'US')
	    country = member.country;
	  var fields = this.getAddressFieldsByCountryCode(country);
	  for(var index in fields){  //cycle through fields for country
	    if(fields[index].answerRequired){  //only check required fields
	      var name = (fields[index].name === 'zipcode')? 'zip' : fields[index].name; //translate zipcode name
	      if(member[name] && member[name] !== ""){
	        var partial = true;
	      }else{
	        var completed = false;
	      }
	    }
	  }
	  if(completed)
	    return 'complete';
	  else if(partial)
	    return 'partial';
	  else
	    return 'empty';
	}
	var CountryField = function(countryName) {
	    return {
	        countryName: countryName,
	        name: "country",
	        label: labels.country,
	        answerRequired: true
	    }
	}
	var AddressField = function(suffix, label) {
	    if (!suffix || !label) {
	        return null
	    }
	    var required = true;
	    return {
	        name: suffix,
	        label: label,
	        answerRequired: required
	    }
	}
	var City = function(cityName) {
	    return AddressField("city", cityName)
	}
	var State = function(stateName) {
	    return AddressField("state", stateName)
	}
	var Zip = function(zipName) {
	    return AddressField("zipcode", zipName)
	}
	var StreetStreetCity = function() {
	    return [generic.street1, generic.street2, generic.city]
	}
	var StreetStreetPostcodeCity = function() {
	    return [generic.street1, generic.street2, generic.postcode, generic.city]
	}
	var StreetStreetCityPostcode = function() {
	    return [generic.street1, generic.street2, generic.city, generic.postcode]
	}
	var labels = {
	    street1: "Street Address",
	    street2: "Street Address 2",
	    city: "City",
	    province: "Province",
	    state: "State",
	    postalCode: "Postal Code",
	    country: "Country",
	    zipCode: "Zip Code",
	    county: "County",
	    suburb: "Suburb",
	    island: "Island",
	    village: "Village",
	    postalDistrict: "Postal District",
	    governorate: "Governorate",
	    department: "Department",
	    district: "District",
	    pin: "Pin",
	    prefecture: "Prefecture",
	    countyAndCity: "County and City",
	    regionAndDistrict: "Region and District",
	    cityAndDistrict: "City and District",
	    districtOrSubdivision: "District or Subdivision",
	    territory: "Territory",
	    region: "Region",
	    districtAndProvince: "District and Province"
	}
	var generic = {
	    street1: {
	        name: "street1",
	        label: labels.street1,
	        answerRequired: true
	    },
	    street2: {
	        name: "street2",
	        label: labels.street2,
	        answerRequired: false
	    },
	    city: {
	        name: "city",
	        label: labels.city,
	        answerRequired: true
	    },
	    province: {
	        name: "state",
	        label: labels.province,
	        answerRequired: true
	    },
	    state: {
	        name: "state",
	        label: labels.state,
	        answerRequired: true,
	        options: null
	    },
	    postcode: {
	        name: "zipcode",
	        label: labels.postalCode,
	        answerRequired: true
	    }
	};
	var addressFieldsByCountryCode = exports.addressFieldsByCountryCode = {
	    US: [generic.street1, generic.street2, generic.city, {
	        name: "state",
	        label: labels.state,
	        answerRequired: true,
	        options: {
	            AL: "Alabama",
	            AK: "Alaska",
	            AS: "American Samoa",
	            AZ: "Arizona",
	            AR: "Arkansas",
	            AA: "Armed Forces (AA)",
	            AE: "Armed Forces (AE)",
	            AP: "Armed Forces (AP)",
	            CA: "California",
	            CO: "Colorado",
	            CT: "Connecticut",
	            DE: "Delaware",
	            DC: "District of Columbia",
	            FM: "Federated States of Micronesia",
	            FL: "Florida",
	            GA: "Georgia",
	            GU: "Guam",
	            HI: "Hawaii",
	            ID: "Idaho",
	            IL: "Illinois",
	            IN: "Indiana",
	            IA: "Iowa",
	            KS: "Kansas",
	            KY: "Kentucky",
	            LA: "Louisiana",
	            ME: "Maine",
	            MH: "Marshall Islands",
	            MD: "Maryland",
	            MA: "Massachusetts",
	            MI: "Michigan",
	            MN: "Minnesota",
	            MS: "Mississippi",
	            MO: "Missouri",
	            MT: "Montana",
	            NE: "Nebraska",
	            NV: "Nevada",
	            NH: "New Hampshire",
	            NJ: "New Jersey",
	            NM: "New Mexico",
	            NY: "New York",
	            NC: "North Carolina",
	            ND: "North Dakota",
	            MP: "Northern Mariana Islands",
	            OH: "Ohio",
	            OK: "Oklahoma",
	            OR: "Oregon",
	            PW: "Palau",
	            PA: "Pennsylvania",
	            PR: "Puerto Rico",
	            RI: "Rhode Island",
	            SC: "South Carolina",
	            SD: "South Dakota",
	            TN: "Tennessee",
	            TX: "Texas",
	            UT: "Utah",
	            VT: "Vermont",
	            VI: "Virgin Islands",
	            VA: "Virginia",
	            WA: "Washington",
	            WV: "West Virginia",
	            WI: "Wisconsin",
	            WY: "Wyoming"
	        }
	    }, {
	        name: "zipcode",
	        label: labels.zipCode,
	        regex: "(^\\d{5}$)|(^\\d{5}-\\d{4}$)",
	        regexErrorMessage: "Please supply a 5-digit US zip code.",
	        answerRequired: true
	    }],
	    CA: [generic.street1, generic.street2, generic.city, {
	        name: "state",
	        label: labels.province,
	        answerRequired: true,
	        options: {
	            AB: "Alberta",
	            BC: "British Columbia",
	            MB: "Manitoba",
	            NB: "New Brunswick",
	            NL: "Newfoundland and Labrador",
	            NS: "Nova Scotia",
	            NT: "Northwest Territories",
	            NU: "Nunavut",
	            ON: "Ontario",
	            PE: "Prince Edward Island",
	            QC: "Quebec",
	            SK: "Saskatchewan",
	            YT: "Yukon"
	        }
	    }, {
	        name: "zipcode",
	        label: labels.postalCode,
	        convertToUppercaseBeforeValidation: true,
	        regex: "^[ABCEGHJKLMNPRSTVXY]\\d[A-Z] \\d[A-Z]\\d$",
	        regexErrorMessage: "Please supply a Canadian postal code, following format A0A 0A0, where A is a letter and 0 is a digit, with a space separating the third and fourth characters.",
	        answerRequired: true
	    }],
	    GB: [generic.street1, generic.street2, generic.city, State(labels.county), generic.postcode],
	    AX: StreetStreetPostcodeCity(),
	    AF: StreetStreetPostcodeCity(),
	    AL: StreetStreetCity(),
	    AS: StreetStreetPostcodeCity(),
	    AD: StreetStreetPostcodeCity(),
	    AO: StreetStreetCity(),
	    AI: StreetStreetPostcodeCity(),
	    AQ: StreetStreetPostcodeCity(),
	    AG: StreetStreetCity(),
	    AR: [generic.street1, generic.street2, generic.postcode, generic.city, generic.province],
	    AM: StreetStreetPostcodeCity(),
	    AW: StreetStreetPostcodeCity(),
	    AU: [generic.street1, generic.street2, City(labels.suburb), generic.state, generic.postcode],
	    AT: StreetStreetPostcodeCity(),
	    AZ: StreetStreetPostcodeCity(),
	    BS: [generic.street1, generic.street2, generic.city, State(labels.county)],
	    BH: StreetStreetCityPostcode(),
	    BD: StreetStreetCityPostcode(),
	    BB: StreetStreetCity(),
	    BY: [generic.street1, generic.street2, generic.postcode, generic.city, generic.province],
	    BE: StreetStreetPostcodeCity(),
	    BZ: [generic.street1, generic.street2, generic.city, generic.province],
	    BJ: StreetStreetCity(),
	    BM: StreetStreetCityPostcode(),
	    BT: StreetStreetCity(),
	    BO: StreetStreetCity(),
	    BA: StreetStreetPostcodeCity(),
	    BW: StreetStreetCity(),
	    BV: StreetStreetPostcodeCity(),
	    BR: [generic.street1, generic.street2, generic.postcode, generic.city, generic.province],
	    IO: StreetStreetPostcodeCity(),
	    VG: StreetStreetPostcodeCity(),
	    BN: StreetStreetCityPostcode(),
	    BG: StreetStreetPostcodeCity(),
	    BF: StreetStreetPostcodeCity(),
	    BI: StreetStreetCity(),
	    KH: StreetStreetCityPostcode(),
	    CM: StreetStreetCity(),
	    CV: StreetStreetPostcodeCity(),
	    KY: [generic.street1, generic.street2, City(labels.island)],
	    CF: StreetStreetCity(),
	    TD: StreetStreetCity(),
	    CL: StreetStreetPostcodeCity(),
	    CN: [generic.street1, generic.street2, generic.postcode, generic.city, generic.province],
	    CX: StreetStreetPostcodeCity(),
	    CC: StreetStreetPostcodeCity(),
	    CO: StreetStreetCity(),
	    KM: StreetStreetCity(),
	    CD: StreetStreetPostcodeCity(),
	    CG: StreetStreetCity(),
	    CK: StreetStreetPostcodeCity(),
	    CR: StreetStreetPostcodeCity(),
	    CI: StreetStreetPostcodeCity(),
	    HR: StreetStreetPostcodeCity(),
	    CU: StreetStreetPostcodeCity(),
	    CY: StreetStreetPostcodeCity(),
	    CZ: StreetStreetPostcodeCity(),
	    DK: [generic.street1, generic.street2, generic.postcode, State(labels.city), City(labels.village)],
	    DJ: StreetStreetCity(),
	    DM: StreetStreetCity(),
	    DO: [generic.street1, generic.street2, State(labels.postalDistrict), generic.postcode, generic.city],
	    EC: [generic.street1, generic.street2, generic.postcode, generic.city],
	    EG: [generic.street1, generic.street2, City(labels.postalDistrict), State(labels.governorate), generic.postcode],
	    SV: [generic.street1, generic.street2, generic.postcode, generic.city, State(labels.department)],
	    GQ: StreetStreetCity(),
	    ER: StreetStreetCity(),
	    EE: StreetStreetPostcodeCity(),
	    ET: StreetStreetPostcodeCity(),
	    FK: StreetStreetCityPostcode(),
	    FO: StreetStreetPostcodeCity(),
	    FJ: [generic.street1, generic.street2, State(labels.district), generic.city],
	    FI: StreetStreetPostcodeCity(),
	    FR: StreetStreetPostcodeCity(),
	    GF: StreetStreetPostcodeCity(),
	    PF: [generic.street1, generic.street2, generic.postcode, generic.city, State(labels.island)],
	    TF: StreetStreetPostcodeCity(),
	    GA: StreetStreetPostcodeCity(),
	    GM: StreetStreetCity(),
	    GE: StreetStreetPostcodeCity(),
	    DE: StreetStreetPostcodeCity(),
	    GH: StreetStreetPostcodeCity(),
	    GI: StreetStreetPostcodeCity(),
	    GR: StreetStreetPostcodeCity(),
	    GL: [generic.street1, generic.street2, generic.postcode, State(labels.postalDistrict)],
	    GD: StreetStreetCity(),
	    GP: StreetStreetPostcodeCity(),
	    GU: StreetStreetPostcodeCity(),
	    GT: StreetStreetPostcodeCity(),
	    GN: StreetStreetPostcodeCity(),
	    GW: StreetStreetPostcodeCity(),
	    GY: StreetStreetCity(),
	    HT: StreetStreetPostcodeCity(),
	    HM: StreetStreetPostcodeCity(),
	    HN: [generic.street1, generic.street2, generic.postcode, generic.city, State(labels.department)],
	    HK: [generic.street1, generic.street2, City(labels.district), generic.province, Zip(labels.state)],
	    HU: [generic.postcode, generic.city, generic.street1, generic.street2],
	    IS: StreetStreetPostcodeCity(),
	    IN: [generic.street1, generic.street2, generic.province, generic.city, Zip(labels.pin)],
	    ID: [generic.street1, generic.street2, generic.city, generic.province, generic.postcode],
	    IR: StreetStreetPostcodeCity(),
	    IQ: StreetStreetCityPostcode(),
	    IE: [generic.street1, generic.street2, generic.city, State(labels.county), generic.postcode],
	    IM: StreetStreetCityPostcode(),
	    IL: StreetStreetPostcodeCity(),
	    IT: [generic.street1, generic.street2, generic.postcode, generic.city, generic.province],
	    JM: StreetStreetCityPostcode(),
	    JP: [generic.postcode, State(labels.prefecture), City(labels.countyAndCity), generic.street1, generic.street2],
	    JO: [State(labels.regionAndDistrict), generic.street1, generic.street2, City(labels.city), generic.postcode],
	    KZ: [generic.street1, generic.street2, City(labels.cityAndDistrict), generic.province, generic.postcode],
	    KE: [generic.street1, generic.street2, generic.city, generic.postcode],
	    KI: [generic.street1, generic.street2, generic.city, State(labels.island)],
	    KW: [generic.street1, generic.street2, generic.postcode, generic.city, generic.province],
	    KG: [generic.postcode, generic.city, generic.street1, generic.street2],
	    LA: StreetStreetPostcodeCity(),
	    LV: StreetStreetCityPostcode(),
	    LB: StreetStreetCityPostcode(),
	    LS: StreetStreetCityPostcode(),
	    LR: StreetStreetPostcodeCity(),
	    LY: StreetStreetCity(),
	    LI: StreetStreetPostcodeCity(),
	    LT: StreetStreetPostcodeCity(),
	    LU: StreetStreetPostcodeCity(),
	    MO: StreetStreetCity(),
	    MK: StreetStreetCityPostcode(),
	    MG: StreetStreetPostcodeCity(),
	    MW: StreetStreetCityPostcode(),
	    MY: [generic.street1, generic.street2, generic.postcode, generic.city, generic.state],
	    MV: StreetStreetCityPostcode(),
	    ML: StreetStreetCity(),
	    MT: StreetStreetCityPostcode(),
	    MH: StreetStreetPostcodeCity(),
	    MQ: StreetStreetPostcodeCity(),
	    MR: StreetStreetCity(),
	    MU: StreetStreetPostcodeCity(),
	    YT: StreetStreetPostcodeCity(),
	    MX: [generic.street1, generic.street2, generic.postcode, generic.city, generic.state],
	    FM: StreetStreetPostcodeCity(),
	    MD: StreetStreetPostcodeCity(),
	    MC: StreetStreetPostcodeCity(),
	    MN: StreetStreetCityPostcode(),
	    MS: StreetStreetPostcodeCity(),
	    MA: StreetStreetPostcodeCity(),
	    MZ: [generic.street1, generic.street2, generic.postcode, generic.city, generic.province],
	    MM: StreetStreetCityPostcode(),
	    NA: StreetStreetCity(),
	    NP: StreetStreetCityPostcode(),
	    NL: StreetStreetPostcodeCity(),
	    AN: StreetStreetPostcodeCity(),
	    NC: StreetStreetPostcodeCity(),
	    NZ: [generic.street1, generic.street2, State(labels.suburb), generic.city, generic.postcode],
	    NI: [generic.street1, generic.street2, generic.postcode, generic.city, State(labels.department)],
	    NE: StreetStreetPostcodeCity(),
	    NG: [generic.street1, generic.street2, generic.city, generic.postcode, generic.state],
	    NU: StreetStreetPostcodeCity(),
	    NF: StreetStreetPostcodeCity(),
	    KP: StreetStreetCity(),
	    MP: StreetStreetPostcodeCity(),
	    NO: StreetStreetPostcodeCity(),
	    OM: [generic.street1, generic.street2, generic.postcode, generic.city, generic.province],
	    PK: StreetStreetCityPostcode(),
	    PW: StreetStreetPostcodeCity(),
	    PS: StreetStreetPostcodeCity(),
	    PA: [generic.street1, generic.street2, generic.postcode, generic.city, generic.province],
	    PG: [generic.street1, generic.street2, generic.city, generic.postcode, generic.province],
	    PY: StreetStreetPostcodeCity(),
	    PE: [generic.street1, generic.street2, generic.city, generic.postcode],
	    PH: [generic.street1, AddressField("street2", labels.districtOrSubdivision), generic.postcode, generic.city],
	    PN: StreetStreetPostcodeCity(),
	    PL: [generic.street1, generic.street2, generic.postcode, generic.city, generic.state],
	    PT: [generic.street1, generic.street2, generic.postcode, generic.city, State(labels.territory)],
	    PR: StreetStreetPostcodeCity(),
	    QA: StreetStreetPostcodeCity(),
	    NR: StreetStreetCity(),
	    RE: StreetStreetPostcodeCity(),
	    RO: StreetStreetPostcodeCity(),
	    RU: [generic.street1, generic.street2, generic.city, generic.province, generic.postcode],
	    RW: StreetStreetCity(),
	    SH: StreetStreetCityPostcode(),
	    KN: StreetStreetPostcodeCity(),
	    LC: StreetStreetCity(),
	    PM: StreetStreetPostcodeCity(),
	    VC: StreetStreetCity(),
	    WS: StreetStreetCity(),
	    SM: StreetStreetPostcodeCity(),
	    ST: StreetStreetCity(),
	    SA: StreetStreetCityPostcode(),
	    SN: StreetStreetPostcodeCity(),
	    CS: [generic.street1, generic.street2, generic.postcode, generic.city, generic.state],
	    SC: StreetStreetCity(),
	    SL: StreetStreetCity(),
	    SG: StreetStreetCityPostcode(),
	    SK: StreetStreetPostcodeCity(),
	    SI: StreetStreetPostcodeCity(),
	    SB: StreetStreetCity(),
	    SO: [generic.street1, generic.street2, generic.city, State(labels.region), generic.postcode],
	    ZA: [generic.street1, generic.street2, generic.city, generic.province, generic.postcode],
	    GS: StreetStreetCityPostcode(),
	    KR: [generic.postcode, generic.province, generic.city, generic.street1, generic.street2],
	    ES: [generic.street1, generic.street2, generic.postcode, generic.city, generic.province],
	    LK: StreetStreetCityPostcode(),
	    SD: StreetStreetPostcodeCity(),
	    SR: [generic.street1, generic.street2, generic.city, State(labels.postalDistrict)],
	    SJ: StreetStreetPostcodeCity(),
	    SZ: StreetStreetCityPostcode(),
	    SE: StreetStreetPostcodeCity(),
	    CH: StreetStreetPostcodeCity(),
	    SY: StreetStreetPostcodeCity(),
	    TW: [generic.street1, generic.street2, generic.city, State(labels.island), generic.postcode],
	    TJ: StreetStreetPostcodeCity(),
	    TH: [generic.street1, generic.street2, generic.province, generic.city, generic.postcode],
	    TL: StreetStreetCity(),
	    TG: StreetStreetCity(),
	    TK: StreetStreetPostcodeCity(),
	    TO: StreetStreetCity(),
	    TT: StreetStreetCity(),
	    TN: StreetStreetPostcodeCity(),
	    TR: StreetStreetPostcodeCity(),
	    TM: StreetStreetPostcodeCity(),
	    TC: StreetStreetPostcodeCity(),
	    TV: StreetStreetCity(),
	    UG: StreetStreetCity(),
	    UA: [generic.street1, generic.street2, generic.city, State(labels.districtAndProvince), generic.postcode],
	    AE: StreetStreetPostcodeCity(),
	    TZ: StreetStreetCity(),
	    UM: StreetStreetPostcodeCity(),
	    VI: StreetStreetPostcodeCity(),
	    UY: [generic.street1, generic.street2, generic.postcode, generic.city, State(labels.department)],
	    UZ: StreetStreetCityPostcode(),
	    VU: StreetStreetCity(),
	    VA: StreetStreetPostcodeCity(),
	    VE: [generic.street1, generic.street2, generic.city, generic.postcode, generic.state],
	    VN: [generic.street1, generic.street2, generic.province, generic.city, generic.postcode],
	    WF: StreetStreetPostcodeCity(),
	    EH: StreetStreetPostcodeCity(),
	    YE: StreetStreetPostcodeCity(),
	    ZM: StreetStreetPostcodeCity(),
	    ZW: StreetStreetCity(),
	    DEFAULT: StreetStreetCity()
	};

	//CREDIT CARD + SECURITY CODE VALIDATOR
	//COPIED FROM https://github.com/braintree/credit-card-type/blob/master/index.js

	//Modified by Philip for simplifcation to prevent potential browser var name conflicts
	var testOrder = [
	  'visa',
	  'master-card',
	  'american-express',
	  'diners-club',
	  'discover',
	  'jcb',
	  'unionpay',
	  'maestro'
	];

	function cardValidator_clone(x) {
	  var prefixPattern, exactPattern, dupe;
	  if (!x) { return null; }
	  prefixPattern = x.prefixPattern.source;
	  exactPattern = x.exactPattern.source;
	  dupe = JSON.parse(JSON.stringify(x));
	  dupe.prefixPattern = prefixPattern;
	  dupe.exactPattern = exactPattern;

	  return dupe;
	}

	var creditCardTypes = {
	  'visa':{
	    niceType: 'Visa',
	    type: 'visa',
	    prefixPattern: /^4$/,
	    exactPattern: /^4\d*$/,
	    gaps: [4, 8, 12],
	    lengths: [13, 16, 18, 19],     //I (Phil) added 13 digit option just in case. It was a pre-2005 visa length which could be a potential edge case.
	    code: {
	      name: 'CVV',
	      size: 3
	    }
	  },
	  'master-card':{
	    niceType: 'MasterCard',
	    type: 'master-card',
	    prefixPattern: /^(5|5[1-5]|2|22|222|222[1-9]|2[3-6]|27[0-1]|2720)$/,
	    exactPattern: /^(5[1-5]|222[1-9]|2[3-6]|27[0-1]|2720)\d*$/,
	    gaps: [4, 8, 12],
	    lengths: [16],
	    code: {
	      name: 'CVC',
	      size: 3
	    }
	  },
	  'american-express':{
	    niceType: 'American Express',
	    type: 'american-express',
	    prefixPattern: /^(3|34|37)$/,
	    exactPattern: /^3[47]\d*$/,
	    isAmex: true,
	    gaps: [4, 10],
	    lengths: [15],
	    code: {
	      name: 'CID',
	      size: 4
	    }
	  },
	  'diners-club':{
	    niceType: 'Diners Club',
	    type: 'diners-club',
	    prefixPattern: /^(3|3[0689]|30[0-5])$/,
	    exactPattern: /^3(0[0-5]|[689])\d*$/,
	    gaps: [4, 10],
	    lengths: [14],
	    code: {
	      name: 'CVV',
	      size: 3
	    }
	  },
	  'discover':{
	    niceType: 'Discover',
	    type: 'discover',
	    prefixPattern: /^(6|60|601|6011|65|64|64[4-9])$/,
	    exactPattern: /^(6011|65|64[4-9])\d*$/,
	    gaps: [4, 8, 12],
	    lengths: [16, 19],
	    code: {
	      name: 'CID',
	      size: 3
	    }
	  },
	  'jcb':{
	    niceType: 'jcb',
	    type: 'jcb',
	    prefixPattern: /^(2|21|213|2131|1|18|180|1800|3|35)$/,
	    exactPattern: /^(2131|1800|35)\d*$/,
	    gaps: [4, 8, 12],
	    lengths: [16],
	    code: {
	      name: 'CVV',
	      size: 3
	    }
	  },
	  'unionpay':{
	    niceType: 'UnionPay',
	    type: 'unionpay',
	    prefixPattern: /^(6|62)$/,
	    exactPattern: /^62\d*$/,
	    gaps: [4, 8, 12],
	    lengths: [16, 17, 18, 19],
	    code: {
	      name: 'CVN',
	      size: 3
	    }
	  },
	  'maestro':{
	    niceType: 'Maestro',
	    type: 'maestro',
	    prefixPattern: /^(5|5[06-9]|6\d*)$/,
	    exactPattern: /^5[06-9]\d*$/,
	    gaps: [4, 8, 12],
	    lengths: [12, 13, 14, 15, 16, 17, 18, 19],
	    code: {
	      name: 'CVC',
	      size: 3
	    }
	  }
	}

	exports.creditCardType = function(cardNumber) {
	  var type, value, i;
	  var prefixResults = [];
	  var exactResults = [];

	  if (!(typeof cardNumber === 'string' || cardNumber instanceof String)) {
	    return [];
	  }

	  for (i = 0; i < testOrder.length; i++) {
	    type = testOrder[i];
	    value = creditCardTypes[type];

	    if (cardNumber.length === 0) {
	      prefixResults.push(cardValidator_clone(value));
	      continue;
	    }

	    if (value.exactPattern.test(cardNumber)) {
	      exactResults.push(cardValidator_clone(value));
	    } else if (value.prefixPattern.test(cardNumber)) {
	      prefixResults.push(cardValidator_clone(value));
	    }
	  }

	  return exactResults.length ? exactResults : prefixResults;
	}
})(typeof exports === 'undefined'? this['sharedFunctions']={}: exports);